import { render, staticRenderFns } from "./ApprovalEmpty.vue?vue&type=template&id=03ad6d98&"
import script from "./ApprovalEmpty.vue?vue&type=script&lang=ts&"
export * from "./ApprovalEmpty.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports